var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 49,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    x: 0.5,
    y: 0.5,
    fill: "#fde8e8",
    rx: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d92b2b",
    d: "m31.77 16.15-5.1 5.1H15.7c-.66 0-1.2-.54-1.2-1.2v-.01c0-2.29 1.85-4.14 4.14-4.14h11.71c.5 0 .98.09 1.42.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d92b2b",
    stroke: "#d92b2b",
    d: "M15.7 23.25h8.263l-4.5 4.5H18.5c-.686 0-1.25.564-1.25 1.25 0 .266.088.518.237.725l-1.606 1.606A3.6 3.6 0 0 1 15 28.96v-5.01c0-.384.316-.7.7-.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d92b2b",
    d: "M34.5 23.5v5.46c0 2.29-1.85 4.14-4.14 4.14h-9.05c-.89 0-1.34-1.08-.71-1.71l1.35-1.35a1 1 0 0 1 .71-.29H27c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-.84c-.89 0-1.34-1.08-.71-1.71l3.46-3.46c.38-.37.89-.58 1.42-.58h3.17c.55 0 1 .45 1 1m-.23-8.77c-.3-.3-.79-.3-1.09 0L14.73 33.19c-.3.3-.3.79 0 1.09a.76.76 0 0 0 1.08-.01l18.46-18.46c.31-.3.31-.78 0-1.08"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d92b2b",
    d: "m34.27 15.81-1.16 1.16-4.28 4.28-13.02 13.02c-.15.15-.34.23-.54.23s-.39-.08-.54-.23a.743.743 0 0 1 0-1.08l1.15-1.15 2.35-2.35 13.54-13.54 1.42-1.42c.3-.31.78-.31 1.08 0 .31.3.31.78 0 1.08m.23 4.1c0-.89-1.08-1.34-1.71-.71l-.29.3-.29.29c-.63.63-.19 1.71.7 1.71h.59c.55 0 1-.45 1-1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.b44a5754a431625f573368cd800b886c.svg";
export { ForwardRef as ReactComponent };